import {Column} from "../atoms/Layout.tsx";
import Logo from "../atoms/Logo.tsx";
import {Text} from "../style/typography.tsx";

const LogoWithTitle = () => {
    return <Column centerHorizontally gap="20">
        <Logo size="large" />
        <Text role="heading" size="3" weight="semiBold">ClearTrack</Text>
    </Column>
}

export default LogoWithTitle;